
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6aa4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6aa4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lCBL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbda6f76a78de32b$export$2e2bcd8739ae039);
// ── Dark / Light theme toggle ──────────────────────────────────────────
// Persists preference to localStorage and flips a data-theme attribute
// on <html>. Light theme colors are defined in sass/theme/_light.scss.
const $fbda6f76a78de32b$var$STORAGE_KEY = "portfolio-theme";
function $fbda6f76a78de32b$var$applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme);
    const btn = document.getElementById("theme-toggle-btn");
    if (btn) {
        btn.setAttribute("aria-label", theme === "light" ? "Switch to dark mode" : "Switch to light mode");
        btn.classList.toggle("is-light", theme === "light");
    }
}
function $fbda6f76a78de32b$export$2e2bcd8739ae039() {
    $fbda6f76a78de32b$var$applyTheme("light");
    const btn = document.getElementById("theme-toggle-btn");
    if (!btn) return;
    btn.addEventListener("click", ()=>{
        const current = document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark";
        const next = current === "light" ? "dark" : "light";
        $fbda6f76a78de32b$var$applyTheme(next);
    });
}

});

parcelRegister("lgaAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a34e1d8dc8f481$export$2e2bcd8739ae039);
// ── Resume dropdown (header, top right) ───────────────────────────────
function $f7a34e1d8dc8f481$export$2e2bcd8739ae039() {
    const dd = document.getElementById("resume-dd");
    const btn = document.getElementById("resume-dd-btn");
    if (!dd || !btn) return;
    const setOpen = (open)=>{
        dd.classList.toggle("is-open", open);
        btn.setAttribute("aria-expanded", String(open));
    };
    btn.addEventListener("click", (e)=>{
        e.stopPropagation();
        setOpen(!dd.classList.contains("is-open"));
    });
    dd.querySelectorAll("a").forEach((a)=>a.addEventListener("click", ()=>setOpen(false)));
    document.addEventListener("click", (e)=>{
        if (!dd.contains(e.target)) setOpen(false);
    });
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") setOpen(false);
    });
}

});


var $lCBL2 = parcelRequire("lCBL2");

var $lgaAv = parcelRequire("lgaAv");
// ── Certificate image viewer (same lightbox as the Projects section) ──
function $278b46698cf92015$var$initCertLightbox() {
    let lb = document.getElementById("exp-lightbox");
    if (!lb) {
        lb = document.createElement("div");
        lb.id = "exp-lightbox";
        lb.innerHTML = `
      <div id="exp-lightbox-overlay"></div>
      <button id="exp-lightbox-close" aria-label="Close">\u{2715}</button>
      <button id="exp-lightbox-prev" aria-label="Previous image">&lsaquo;</button>
      <button id="exp-lightbox-next" aria-label="Next image">&rsaquo;</button>
      <div id="exp-lightbox-content">
        <img id="exp-lightbox-img" src="about:blank" alt="" />
        <span id="exp-lightbox-count"></span>
      </div>`;
        document.body.appendChild(lb);
    }
    const lbImg = lb.querySelector("#exp-lightbox-img");
    const lbCount = lb.querySelector("#exp-lightbox-count");
    const cards = Array.from(document.querySelectorAll(".cert-card"));
    let idx = 0;
    const show = (i)=>{
        idx = (i + cards.length) % cards.length;
        const img = cards[idx].querySelector("img");
        lbImg.src = img.currentSrc || img.src;
        lbCount.textContent = cards.length > 1 ? `${idx + 1} / ${cards.length}` : "";
    };
    const open = (i)=>{
        show(i);
        lb.classList.add("active");
        document.body.style.overflow = "hidden";
    };
    const close = ()=>{
        lb.classList.remove("active");
        document.body.style.overflow = "";
    };
    cards.forEach((card, i)=>{
        card.addEventListener("click", ()=>open(i));
        card.addEventListener("keydown", (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                open(i);
            }
        });
    });
    lb.querySelector("#exp-lightbox-close").addEventListener("click", close);
    lb.querySelector("#exp-lightbox-overlay").addEventListener("click", close);
    lb.querySelector("#exp-lightbox-prev").addEventListener("click", ()=>show(idx - 1));
    lb.querySelector("#exp-lightbox-next").addEventListener("click", ()=>show(idx + 1));
    document.addEventListener("keydown", (e)=>{
        if (!lb.classList.contains("active")) return;
        if (e.key === "Escape") close();
        if (e.key === "ArrowLeft") show(idx - 1);
        if (e.key === "ArrowRight") show(idx + 1);
    });
}
// ── Fluid lens cursor (desktop only) ──────────────────────────────────
function $278b46698cf92015$var$initLens() {
    const lens = document.getElementById("fluid-lens");
    if (!lens) return;
    if (window.innerWidth <= 1024) {
        lens.style.display = "none";
        return;
    }
    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight * 0.22;
    let lensX = mouseX;
    let lensY = mouseY;
    document.addEventListener("mousemove", (e)=>{
        mouseX = e.clientX;
        mouseY = e.clientY;
    });
    (function animateLens() {
        lensX += (mouseX - lensX) * 0.3;
        lensY += (mouseY - lensY) * 0.3;
        lens.style.left = lensX + "px";
        lens.style.top = lensY + "px";
        requestAnimationFrame(animateLens);
    })();
    document.querySelectorAll("a, button, .cert-card").forEach((el)=>{
        el.addEventListener("mouseenter", ()=>lens.classList.add("hovering"));
        el.addEventListener("mouseleave", ()=>lens.classList.remove("hovering"));
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    $278b46698cf92015$var$initCertLightbox(); // first, so nothing below can stop it
    (0, $lCBL2.default)();
    (0, $lgaAv.default)();
    $278b46698cf92015$var$initLens();
    const header = document.getElementById("site-header");
    const update = ()=>header && header.classList.toggle("is-scrolled", window.scrollY > 80);
    update();
    window.addEventListener("scroll", update, {
        passive: true
    });
});


//# sourceMappingURL=certifications.07aa04c0.js.map
